/* AUTO-GENERATED icon registry — only icons the God Console uses. */
import {
  Activity,
  AlertOctagon,
  AlertTriangle,
  Hash,
  Image,
  ArrowLeft,
  ArrowLeftRight,
  ArrowUpRight,
  Banknote,
  Bell,
  Brain,
  BrainCircuit,
  Building2,
  Calculator,
  Check,
  CheckCheck,
  CheckSquare,
  ChevronDown,
  ChevronRight,
  Circle,
  Copy,
  Cpu,
  CreditCard,
  Crown,
  DollarSign,
  Download,
  Eye,
  EyeOff,
  FastForward,
  FileCode2,
  FileLock2,
  Flag,
  Flame,
  Gauge,
  Gift,
  GitCommitHorizontal,
  Globe,
  GraduationCap,
  Hammer,
  History,
  IdCard,
  Inbox,
  Info,
  KeyRound,
  Layers,
  Library,
  Link,
  ShieldCheck,
  FileText,
  List,
  LogIn,
  LogOut,
  Mail,
  Megaphone,
  MessageSquare,
  Mic,
  Ear,
  Ruler,
  Shuffle,
  Sigma,
  MonitorSmartphone,
  MoreHorizontal,
  Package,
  Pause,
  Pencil,
  Percent,
  Plus,
  Power,
  Radar,
  Receipt,
  ReceiptText,
  RotateCcw,
  Route,
  Search,
  Send,
  Server,
  Settings,
  Settings2,
  Shield,
  ShieldAlert,
  SlidersHorizontal,
  Sparkles,
  Table,
  Terminal,
  TicketPercent,
  Timer,
  Trash2,
  TrendingUp,
  Undo2,
  Upload,
  UserMinus,
  UserPlus,
  UserRound,
  UserX,
  Users,
  VenetianMask,
  Wrench,
  X,
  XCircle,
  Zap,
} from "lucide-react";
import type { ComponentType } from "react";

export const FallbackIcon = Circle;

export const ICON_REGISTRY: Record<string, ComponentType<any>> = {
  "activity": Activity,
  "hash": Hash,
  "image": Image,
  "alert-octagon": AlertOctagon,
  "alert-triangle": AlertTriangle,
  "arrow-left": ArrowLeft,
  "arrow-left-right": ArrowLeftRight,
  "arrow-up-right": ArrowUpRight,
  "banknote": Banknote,
  "bell": Bell,
  "brain": Brain,
  "brain-circuit": BrainCircuit,
  "building-2": Building2,
  "calculator": Calculator,
  "check": Check,
  "check-check": CheckCheck,
  "copy": Copy,
  "check-square": CheckSquare,
  "chevron-down": ChevronDown,
  "chevron-right": ChevronRight,
  "circle": Circle,
  "cpu": Cpu,
  "mic": Mic,
  "ear": Ear,
  "ruler": Ruler,
  "shuffle": Shuffle,
  "sigma": Sigma,
  "credit-card": CreditCard,
  "crown": Crown,
  "dollar-sign": DollarSign,
  "download": Download,
  "eye": Eye,
  "eye-off": EyeOff,
  "library": Library,
  "fast-forward": FastForward,
  "file-code-2": FileCode2,
  "file-lock-2": FileLock2,
  "flag": Flag,
  "flame": Flame,
  "gauge": Gauge,
  "gift": Gift,
  "git-commit-horizontal": GitCommitHorizontal,
  "globe": Globe,
  "graduation-cap": GraduationCap,
  "hammer": Hammer,
  "history": History,
  "id-card": IdCard,
  "inbox": Inbox,
  "info": Info,
  "key-round": KeyRound,
  "layers": Layers,
  "link": Link,
  "shield-check": ShieldCheck,
  "file-text": FileText,
  "list": List,
  "log-in": LogIn,
  "log-out": LogOut,
  "mail": Mail,
  "megaphone": Megaphone,
  "message-square": MessageSquare,
  "monitor-smartphone": MonitorSmartphone,
  "more-horizontal": MoreHorizontal,
  "package": Package,
  "pause": Pause,
  "pencil": Pencil,
  "percent": Percent,
  "plus": Plus,
  "power": Power,
  "radar": Radar,
  "receipt": Receipt,
  "receipt-text": ReceiptText,
  "rotate-ccw": RotateCcw,
  "route": Route,
  "search": Search,
  "send": Send,
  "server": Server,
  "settings": Settings,
  "settings-2": Settings2,
  "shield": Shield,
  "shield-alert": ShieldAlert,
  "sliders-horizontal": SlidersHorizontal,
  "sparkles": Sparkles,
  "table": Table,
  "terminal": Terminal,
  "ticket-percent": TicketPercent,
  "timer": Timer,
  "trash-2": Trash2,
  "trending-up": TrendingUp,
  "undo-2": Undo2,
  "upload": Upload,
  "user-minus": UserMinus,
  "user-plus": UserPlus,
  "user-round": UserRound,
  "user-x": UserX,
  "users": Users,
  "venetian-mask": VenetianMask,
  "wrench": Wrench,
  "x": X,
  "x-circle": XCircle,
  "zap": Zap,
};
